import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {map, concatMap} from 'rxjs/operators';
import {ROUTESURL} from 'src/app/app-routing.model';
import {ValidationbirthdayService} from 'src/app/shared/services/validationbirthday/validationbirthday.service';
import {MergeQuestiondataService} from '../../services/merge-questiondata.service';
import {ProjectOpenapiCastService} from 'build/project/openapi-cast/project/project-openapi-cast.service';
import {IIdentifier, ResponseCheckCodeWithBirthday, ResponseCheckCodeWithoutBirthday, ResponseLoadQuestionContent, ResponseLoadQuestionContentArray} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {IAllFieldItems} from '../../components/field-item-row/row.model';
import {TranslateDesignPipe} from 'src/app/shared/pipes/translate-design/translate-design.pipe';

@Injectable({
   providedIn: 'root'
})
export class IdentificationService {
   
   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);
   public sProjectOpenapi: ProjectOpenapiCastService = inject(ProjectOpenapiCastService);
   public sValidationBirthday: ValidationbirthdayService = inject(ValidationbirthdayService);
   private sMergeQuestion: MergeQuestiondataService = inject (MergeQuestiondataService); 
   private router: Router = inject(Router);

   private identificationToggle: ResponseLoadQuestionContent = {} as ResponseLoadQuestionContent;
   private questionMeta_: IAllFieldItems = {} as IAllFieldItems;
   private path_: string = "project.pages.identification.toggle-button.";
   public birthdayPattern: string = "";
   public startWithoutBirthday: boolean = false;
   public isModule: boolean = false; 

   get questionMeta (): IAllFieldItems {
      return this.questionMeta_;
   }

   constructor () {
   }

   public checkWithBirtday (code: string, birthday: string): Observable<boolean> {
      return this.sProjectOpenapi.checkCodeWithBirthday({code: code, birthday: birthday}).pipe(
         map(value => this.checkResponse(code, {code: value.code!}))
      );
   }

   public checkWithoutBirthday (code: string): Observable<boolean> {
      return this.sProjectOpenapi.checkCodeWithoutBirthday({code: code}).pipe(
         map(value => this.checkResponse(code, {code: value.code!}))
      );
   }

   private checkResponse (code: string, response: ResponseCheckCodeWithBirthday | ResponseCheckCodeWithoutBirthday): boolean {
      return response && 'code' in response && response.code == code ? true : false;
   }

   public checkIsWithBirthday (value: string): boolean {
      this.sValidationBirthday.birthday = !value || value.length == 0
         ? this.startWithoutBirthday ? false : true : value.lastIndexOf('-G') > -1 && value.length - 2 == value.lastIndexOf('-G')
            ? false : value.lastIndexOf('-E') > -1 && value.length - 2 == value.lastIndexOf('-E') ? true : this.startWithoutBirthday ? false : true;

      return this.sValidationBirthday.birthday;
   }

   public setToggle (): void {

      this.identificationToggle.required = this.pTranslateDesign.transform(this.path_ +  "required");
      this.identificationToggle.valid = this.pTranslateDesign.transform(this.path_ + "valid");
      this.identificationToggle.description = this.pTranslateDesign.transform(this.path_ + "description");
      this.identificationToggle.fieldtype = this.pTranslateDesign.transform(this.path_  + "fieldtype");
      this.identificationToggle.attribute_1 = this.pTranslateDesign.transform(this.path_ + "attribute_1");
      this.identificationToggle.attribute_2 = this.pTranslateDesign.transform(this.path_ + 'attribute_2');
      this.identificationToggle.attribute_3 = this.pTranslateDesign.transform(this.path_ + 'attribute_3');
      this.identificationToggle.attribute_4 = this.pTranslateDesign.transform(this.path_ + 'attribute_4');
      this.identificationToggle.attribute_5 = this.pTranslateDesign.transform(this.path_ + 'attribute_5');
      this.setToggleToList();    
   }

   public setToggleToList (): void {
      this.questionMeta_.question_id = "identificationtoggle";

      const res: ResponseLoadQuestionContentArray = {
         question_id: "identificationtoggle",
         responseLoadQuestionContent: this.identificationToggle
      };

      this.sMergeQuestion.setResultLoadQuestionContent(res);
   }

   public setIdentifier (identifier: IIdentifier): void {
      sessionStorage.setItem('birthday', identifier.birthday ? <string>identifier.birthday : '01.01.1900');
      sessionStorage.setItem('code', <string>identifier.code);
   }

   public navigateNextPage (): void {
      this.router.navigate([ROUTESURL.DECLARATION]);
   }
}
